import React, { createContext, useContext } from 'react';
import { isFunction } from 'lodash/lang';

import Button from '../../general/Button';
import Icon from '../../general/Icon';

export const ModalBoxContext = createContext(null);

export function useModalBoxes() {
  return useContext(ModalBoxContext);
}

export function ModalBoxesHeader({ children, onClose }) {
  const { close } = useModalBoxes();

  return (
    <div className="eds-modal-box-header">
      {children}
      <Button
        priority="low"
        size="h40"
        onClick={function() {
          if (isFunction(onClose)) {
            return onClose();
          }
          return close();
        }}
      >
        <Icon>close</Icon>
      </Button>
    </div>
  );
}

export function ModalBoxesBody({ children }) {
  return <div className="eds-modal-box-body">{children}</div>;
}

export function ModalBoxesFooter({ children }) {
  return <div className="eds-modal-box-footer">{children}</div>;
}
